var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectedBlueprintIcon = function SvgSelectedBlueprintIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 73,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6F1F2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M30.375 7.25h-13.5a3.375 3.375 0 0 0-3.375 3.375v51.75a3.375 3.375 0 0 0 3.375 3.375h38.25a3.375 3.375 0 0 0 3.375-3.375v-27M30.375 7.25H31.5c14.912 0 27 12.088 27 27v1.125M30.375 7.25c5.592 0 10.125 4.533 10.125 10.125v4.5a3.375 3.375 0 0 0 3.375 3.375h4.5c5.592 0 10.125 4.533 10.125 10.125"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6F1F2",
    fillOpacity: 0.05,
    d: "M16.875 65.75h38.25a3.375 3.375 0 0 0 3.375-3.375v-27c0-5.592-4.533-10.125-10.125-10.125h-4.5a3.375 3.375 0 0 1-3.375-3.375v-4.5c0-5.592-4.533-10.125-10.125-10.125h-13.5a3.375 3.375 0 0 0-3.375 3.375v51.75a3.375 3.375 0 0 0 3.375 3.375"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6F1F2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M31.5 7.25h-1.125m28.125 27v1.125M30.375 7.25h-13.5a3.375 3.375 0 0 0-3.375 3.375v51.75a3.375 3.375 0 0 0 3.375 3.375h38.25a3.375 3.375 0 0 0 3.375-3.375v-27M30.375 7.25c5.592 0 10.125 4.533 10.125 10.125v4.5a3.375 3.375 0 0 0 3.375 3.375h4.5c5.592 0 10.125 4.533 10.125 10.125"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#selected-blueprint-icon_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M23.098 55.402a3.75 3.75 0 0 0 5.304 0L34.803 49m-9.053 7.5A3.75 3.75 0 0 1 22 52.75V39.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v4.072M25.75 56.5a3.75 3.75 0 0 0 3.75-3.75v-9.053M25.75 56.5h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M29.5 43.697l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.151 0 1.59L34.803 49m-9.053 3.75h.008v.008h-.008z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "selected-blueprint-icon_svg__a",
    x1: 36.31,
    x2: 25.285,
    y1: 41.809,
    y2: 41.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#EFCDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CCEFF"
  })))));
};
export { SvgSelectedBlueprintIcon as ReactComponent };
export default __webpack_public_path__ + "7f5a039580a2f2620bf065646ee95a7d.svg";